module.exports = __webpack_public_path__ + "assets/img/usdt.e9549c5b.svg";